import Home from '@/views/Home.vue'
import About from '@/views/About.vue'
import S100 from '@/views/S-100.vue'
import Media from '@/views/Media.vue'
import Providers from '@/views/Providers.vue'
import Distributors from '@/views/Distributors.vue'
import Contact from '@/views/Contact.vue'
import Coverage from '@/views/Coverage.vue'
import Updates from '@/views/TextPage'
import ECDIS from '@/views/TextPage'
import BuildFund from '@/views/BuildFund.vue'

import FileCollections from '@/views/restricted/FileCollections'

import adminRoutes from './admin-routes'

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta: {
			title: 'Home',
			icon: 'mdi-home'
		}
	},
	{
		path: '/about',
		name: 'About',
		component: About,
		meta: {
			title: 'About PRIMAR',
			icon: 'mdi-information',
			subLevels: ['Our Vision', 'Guiding Principles']
		}
	},
	{
		path: '/providers',
		name: 'Providers',
		component: Providers,
		meta: {
			title: 'Hydrographic Offices',
			icon: 'mdi-import',
			subLevels: ['Provider Services', 'Provider Network']
		}
	},
	{
        path: '/buildfund',
        name: 'Capacity Build Fund',
        component: BuildFund,
        meta: {
            title: 'Capacity Building Fund',
            icon: 'mdi-refresh',
            contentId: 'buildFund'
        }
    },
	{
		path: '/distributors',
		name: 'Distributors',
		component: Distributors,
		meta: {
			title: 'Distributors',
			icon: 'mdi-export',
			subLevels: ['Mission', 'Distribution Services', 'Distribution Network']
		}
	},	{
		path: '/coverage',
		name: 'Coverage',
		component: Coverage,
		meta: {
			title: 'ENC and S-100 Products Coverage',
			icon: 'mdi-grid'
		}
	},
	{
		path: '/S-100',
		name: 'S-100',
		component: S100,
		meta: {
			title: 'S-100',
			icon: 'mdi-information',
			subLevels: ['Our Vision', 'Guiding Principles']
		}
	},
	{
		path: '/updates',
		name: 'Update',
		component: Updates,
		meta: {
			title: 'Temporary & Preliminary Updates',
			icon: 'mdi-refresh',
			hideInNavbar: true,
			contentId: 'temporary-preliminary'
		}
	},	
	{
		path: '/ecdis',
		name: 'ECDIS',
		component: ECDIS,
		meta: {
			title: 'ECDIS Mandate',
			icon: 'mdi-refresh',
			hideInNavbar: true,
			contentId: 'ecdis-mandate'
		}
	},
	{
		path: '/contact',
		name: 'Contact',
		component: Contact,
		meta: {
			title: 'Contact Us',
			icon: 'mdi-email',
			spacerBefore: true
		}
	},	
	{
		path: '/media',
		name: 'Media',
		component: Media,
		meta: {
			title: 'Media Centre',
			icon: 'mdi-folder-multiple-image'
		}
	},
	{
		path: '/documents/:collection',
		props: true,
		name: 'FileCollection',
		component: FileCollections,
		meta: {
			title: 'File Library',
			icon: 'mdi-file',
			hideInNavbar: true,
			requiresAuth: true,
			noPublicSwitcher: true
		}
	},
	{
		path: '/admin',
		name: 'Admin',
		component: () => import('@/views/admin/AdminContainer'),
		redirect: '/admin/home',
		meta: {
			title: 'Admin panel',
			accessRole: 'Administrators',
			requiresAuth: true,
			hideInNavbar: true,
		},
		children: adminRoutes
	}
]

export default routes